import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
// api
import ApiKey from '../../api/ApiKey';
import BaseApi from '../../api/BaseApi';
// components
import APNavBar from '../Elements/APNavBar';
import APSidebar from '../APSidebar/APSidebar';
// mui
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import { ClearIcon } from '@mui/x-date-pickers';
import BlockIcon from '@mui/icons-material/Block';
import CheckIcon from '@mui/icons-material/Check';
import LoginIcon from '@mui/icons-material/Login';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import VerifiedIcon from '@mui/icons-material/Verified';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { FormControl, IconButton, MenuItem, Select } from '@mui/material';
import { DateUtilsService } from '../../../shared/utils/date-utils.service';

import { Flex, Select as RadixSelect } from"@radix-ui/themes"

const formatDate = dateString => {
  const date = new Date(dateString);
 
  if (isNaN(date)) {
    return 'Invalid date';
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};

const APEmployerList = () => {
  const navigate = useNavigate();
  const tokenKey = Cookies.get('token');
  const { t } = useTranslation('global');
  const adminID = Cookies.get('adminID');

  const [owner, setOwner] = useState("ALL");
  const [status, setStatus] = useState("ALL");
  const [open, setOpen] = useState(false);
  const [symbol, setSymbol] = useState('🔺');
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [selectAll, setSelectAll] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [checkedData, setCheckedData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [positionFrom, setPositionFrom] = useState(0);
  const [managersList, setManagersList] = useState(null);
  const [currentManager, setCurrentManager] = useState('');
  const [sorting, setSorting] = useState({ created: 'desc' });
  const [selectedPayment, setSelectedPayment] = useState(null);

  const page = 1;
  const per_page = 20;

  const indexOfFirstItem = positionFrom;
  const indexOfLastItem = (positionFrom + per_page) >= totalCount ? totalCount : (positionFrom + per_page - 1);

  const handlePageChange = async page => {
    try {
      const positionNumber = page * per_page - per_page;

      setLoading(true);
      setCurrentPage(page);
      setPositionFrom(positionNumber);

      const response = await axios.get(
        BaseApi + '/admin/users/index',
        {
          params: {
            page,
            owner: owner === 'ALL'? null : owner,
            status: status === "ALL"? null : status,
            per_page,
            ...sorting,
            search_query: searchQuery ? searchQuery : null,
            current_grc_manager: {
              id: currentManager ? currentManager : null,
            },
          },
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setListData(response.data.response.user_array.data);
      setTotalCount(response.data.response.user_array.total);
      setPositionFrom(response.data.response.user_array.from);
      setTotalPages(response.data.response.user_array.last_page);
      setCurrentPage(response.data.response.user_array.current_page);
    } catch (error) {
      setLoading(false);

      console.error('Error fetching Jobs List', error);
    }
  };

  const handleOpen = plan => {
    setSelectedPayment(plan);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedPayment(null);
    setOpen(false);
  };

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        BaseApi + '/admin/users/index',
        {
          params: {
            owner: owner === 'ALL'? null : owner,
            status: status === "ALL"? null : status,
            per_page,
            ...sorting,
            page: currentPage,
            search_query: searchQuery ? searchQuery : null,
            current_grc_manager: {
              id: currentManager ? currentManager : null,
            },
          },
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setListData(response.data.response.user_array.data);
      setTotalCount(response.data.response.user_array.total);
      setPositionFrom(response.data.response.user_array.from);
      setManagersList(response.data.response.list_grc_managers);
      setTotalPages(response.data.response.user_array.last_page);
      setCurrentPage(response.data.response.user_array.current_page);
    } catch (error) {
      setLoading(false);

      console.error('Cannot get plans data at APmanageplans', error);
    }
  };

  const handleSearchClick = async e => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await axios.get(
        BaseApi + '/admin/users/index',
        {
          params: {
            page,
            owner: owner === 'ALL'? null : owner,
            status: status === "ALL"? null : status,
            per_page,
            ...sorting,
            search_query: searchQuery ? searchQuery : null,
            current_grc_manager: {
              id: currentManager ? currentManager : null,
            },
          },
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      setLoading(false);
      setListData(response.data.response.user_array.data);
      setTotalCount(response.data.response.user_array.total);
      setPositionFrom(response.data.response.user_array.from);
      setTotalPages(response.data.response.user_array.last_page);
      setCurrentPage(response.data.response.user_array.current_page);
    } catch (error) {
      setLoading(false);

      console.error('Error fetching Employer List', error);
    }
  };

  const handleCheck = id => {
    if (id === 'selectAll') {
      setSelectAll(!selectAll);

      const updatedCheckedData = selectAll
        ? listData.map(item => item.id)
        : [];
      setCheckedData(updatedCheckedData);
    } else {
      if (checkedData.includes(id)) {
        setCheckedData(checkedData.filter(checkedId => checkedId !== id));
      } else {
        setCheckedData([...checkedData, id]);
      }
    }
  };

  const handleActivate = async slug => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Activate Employer?',
        text: 'Do you want to Activate this Employer?',
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/admin/users/activateuser/${slug}`,
          null,
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Employer Activated successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: response.data.message,
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Activate Employer',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t activate the record!', error.message);
    }
  };

  const handleDeactivate = async slug => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Deactivate Employer?',
        text: 'Do you want to Deactivate this Employer?',
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/admin/users/deactivateuser/${slug}`,
          null,
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Employer Deactivated successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: response.data.message,
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Deactivate Employer',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t deactivate the record!', error.message);
    }
  };

  const handleDelete = async slug => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Delete Employer?',
        text: 'Do you want to Delete this Employer?',
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/admin/users/deleteusers/${slug}`,
          null,
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Employer deleted successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: response.data.message,
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Delete Employer',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t delete the record!', error.message);
    }
  };

  const handleVerify = async slug => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Verify Employer?',
        text: 'Do you want to Verify this Employer?',
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          BaseApi + `/admin/users/verifyNow/${slug}`,
          null,
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Employer verified successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: response.data.message,
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Verify Employer',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t delete the record!', error.message);
    }
  };

  const handleLogIn = async employerID => {
    try {
      const response = await axios.get(
        BaseApi + `/admin/auth-user/${employerID}`,
        {
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );

      if (response.data.status === 200) {
        const { role, token, user_id, user_type, employer_id, company_name } = response.data.response.user;

        Cookies.set('user_id', user_id);
        Cookies.set('tokenClient', token);
        Cookies.set('employer_role', role);
        Cookies.set('fname', company_name);
        Cookies.set('user_type', user_type);
        Cookies.set('employer_id', employer_id);

        window.open('/user/managejob', '_blank');
      } else if (response.data.status === 500) {
        Swal.fire({
          icon: 'error',
          confirmButtonText: 'Close',
          title: response.data.message,
        });
      } else {
        Swal.fire({
          icon: 'error',
          confirmButtonText: 'Close',
          title: 'Couldn\'t Log In!',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Log In Employer',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t Log In the Employer!', error.message);
    }
  };

  const handleMultipleDeactivate = async () => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Deactivate Employers?',
        text: 'Do you want to Deactivate Employers?',
      });

      if (confirmationResult.isConfirmed) {
        const ids = checkedData.join(',');

        const response = await axios.post(
          BaseApi + '/admin/users/index',
          {
            idList: ids,
            action: 'deactivate',
          },
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        setSelectAll(true);
        setCheckedData('');

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Employers Deactivated successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: 'Couldn\'t Deactivate!',
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Deactivate Employers',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t deactivate the record!', error.message);
    }
  };

  const handleMultipleActivate = async () => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Activate Employers?',
        text: 'Do you want to Activate Employers?',
      });

      if (confirmationResult.isConfirmed) {
        const ids = checkedData.toString();

        const response = await axios.post(
          BaseApi + '/admin/users/index',
          {
            idList: ids,
            action: 'activate',
          },
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        setSelectAll(true);
        setCheckedData('');

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Employers Activated successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: 'Couldn\'t Activate!',
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Activate Employers',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t activate the record!', error.message);
    }
  };

  const handleMultipleDelete = async () => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        cancelButtonText: 'No',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        title: 'Delete Employers?',
        text: 'Do you want to Delete Employers?',
      });

      if (confirmationResult.isConfirmed) {
        const ids = checkedData.toString();

        const response = await axios.post(
          BaseApi + '/admin/users/index',
          {
            idList: ids,
            action: 'delete',
          },
          {
            headers: {
              key: ApiKey,
              adminid: adminID,
              ContentType: 'application/json',
              Authorization: `Bearer ${tokenKey}`,
            },
          },
        );

        setSelectAll(true);
        setCheckedData('');

        if (response.data.status === 200) {
          Swal.fire({
            icon: 'success',
            confirmButtonText: 'Close',
            title: 'Employers Deleted successfully!',
          });
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'Close',
            title: 'Couldn\'t Delete!',
          });
        }

        getData();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        text: 'Could not Delete Employers',
        title: 'Failed. Please try after some time!',
      });

      console.error('Couldn\'t Delete the record!', error.message);
    }
  };

  const handleColumnClick = async key => {
    const currentDirection = sorting[key] === 'asc' ? 'desc' : 'asc';

    setSymbol(currentDirection === 'desc' ? '🔺' : '🔻');
    setSorting({ [key]: currentDirection });
  };

  const handleSearchChange = e => {
    const newQuery = e.target.value.toLowerCase();
    setSearchQuery(newQuery);
  };

  const handleExport = () => {
    const fileUrl = BaseApi + '/admin/users/generatecsv';

    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = fileUrl;

    link.download = 'Export List';

    document.body.appendChild(link);

    link.click();
  };

  useEffect(() => {
    if (!tokenKey) {

      navigate('/admin');
    } else {
      getData();

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate]); // eslint-disable-line

  useEffect(() => {
    getData();
  }, [sorting]); // eslint-disable-line

  return (
    <>
      <APNavBar />
      <div className='APBasic APManageSubadmin'>
        <APSidebar />
        {
          loading
            ? (
              <div className='loader-container'></div>
            ) : (
              <>
                <div className='site-min-height'>
                  <div className='breadCumb1' role='presentation'>
                    <Breadcrumbs
                      aria-label='breadcrumb'
                      separator={<NavigateNextIcon fontSize='small' />}
                    >
                      <Link
                        underline='hover'
                        color='inherit'
                        onClick={() => navigate('/admin/admins/dashboard')}
                      >
                        Dashboard
                      </Link>
                      <Link
                        underline='hover'
                        color='inherit'
                        onClick={() => navigate('')}
                      >
                        Employers
                      </Link>
                      <Typography color='text.primary'>Employers List</Typography>
                    </Breadcrumbs>
                  </div>
                  <div className='ManageSubAdminHeader'>
                    <h2 className=''>Employer List</h2>
                    <button className='btn navButton1 APMSbutton' onClick={() => handleExport()}>
                      Export Employers
                    </button>
                    <button className='btn navButton1 APMSbutton' onClick={() => navigate('/admin/users/addusers')}>
                      Add Employer
                    </button>
                  </div>
                  <div className='manageSubadminPart1'>
                    <form onSubmit={handleSearchClick}>
                      <div className='manageSubadminPart1Sec1'>
                        <h4 className='mb-4'>
                          Search employer by typing Company name, Company ID, Contact Number or Email
                        </h4>
                        <div className='APDashboardSearchBx '>
                          <input
                            type='text'
                            id='searchQuery'
                            name='searchQuery'
                            value={searchQuery}
                            placeholder='Search..'
                            className='form-control'
                            onChange={handleSearchChange}
                          />
                          <FormControl size='small' sx={{ minWidth: 350, position: 'relative' }}>
                            <Select
                              displayEmpty
                              name='currentManager'
                              value={currentManager}
                              sx={{ height: 50, borderRadius: '6px', pr: currentManager ? 5 : 1.5 }}
                              onChange={e => setCurrentManager(e.target.value || '')}
                              renderValue={val => {
                                if (!val) return 'Select GRC Manager';

                                const m = managersList?.find(mm => mm.id === val);

                                return m ? `${m.first_name} ${m.last_name}` : 'Select GRC Manager';
                              }}
                            >
                              {
                                managersList?.map(m => (
                                  <MenuItem key={m.id} value={m.id}>
                                    {m.first_name} {m.last_name}
                                  </MenuItem>
                                ))
                              }
                            </Select>
                            {
                              currentManager && (
                                <button
                                  type='button'
                                  aria-label='Clear'
                                  onClick={e => {
                                    e.stopPropagation();
                                    setCurrentManager('');
                                  }}
                                  style={{
                                    top: '50%',
                                    right: 26,
                                    width: 28,
                                    height: 28,
                                    border: 'none',
                                    display: 'flex',
                                    cursor: 'pointer',
                                    position: 'absolute',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: 'transparent',
                                    transform: 'translateY(-50%)',
                                  }}
                                >
                                  <ClearIcon fontSize='small' />
                                </button>
                              )
                            }
                          </FormControl>
                          <div className='d-flex align-items-center'>
                            <Flex width="200px">
                                 <RadixSelect.Root 
                            size="3"  
                            value={owner} 
                            onValueChange={(v)=> {
                                setOwner(v)
                            }}
                                 >
                              <RadixSelect.Trigger style={{ width: "100%"}}></RadixSelect.Trigger>
                              <RadixSelect.Content position='popper'> 
                                <Box maxHeight="250px">
                                  {[{value: 'ALL', viewValue: 'Всі'}, 
                                    {value: 0, viewValue: 'Не овнер'}, 
                                    {value: 1, viewValue: 'Oвнер'}, 
                                  ].map(opt=> <RadixSelect.Item key={opt.value} value={opt.value.toString()}>{
                                       opt.viewValue
                                    }</RadixSelect.Item>)}
                                </Box>
                              </RadixSelect.Content>
                            </RadixSelect.Root>

                            </Flex>
                          </div>

                             <div className='d-flex align-items-center'>
                            <Flex width="200px">
                                 <RadixSelect.Root 
                            size="3"  
                            value={status} 
                            onValueChange={(v)=> {
                                setStatus(v)
                            }}
                                 >
                              <RadixSelect.Trigger style={{ width: "100%"}}></RadixSelect.Trigger>
                              <RadixSelect.Content position='popper'> 
                                <Box maxHeight="250px">
                                  {[{value: 'ALL', viewValue: 'Статус'}, 
                                    {value: 0, viewValue: 'Неактивний'}, 
                                    {value: 1, viewValue: 'Активний'}, 
                                  ].map(opt=> <RadixSelect.Item key={opt.value} value={opt.value.toString()}>{
                                       opt.viewValue
                                    }</RadixSelect.Item>)}
                                </Box>
                              </RadixSelect.Content>
                            </RadixSelect.Root>

                            </Flex>
                          </div>
                          <button
                            type='submit'
                            className='btn button1'
                            onClick={handleSearchClick}
                          >
                            Search
                          </button>
                        </div>
                      </div>
                    </form>
                    <h4>
                      {t('pagination.NoofRecords')}
                      {' '}
                      {indexOfFirstItem} - {indexOfLastItem}
                      {' '}{t('pagination.of')}{' '}
                      {totalCount}
                    </h4>
                  </div>
                  {
                    listData != ''
                      ? (
                        <>
                          <div className='manageSubadminPart2'>
                            <table className='table'>
                              <thead>
                                <tr>
                                  <td className='checkBoxCol checkBxHead'>
                                    <input
                                      type='checkbox'
                                      className='tableCheckBox'
                                      onClick={() => handleCheck('selectAll')}
                                    />
                                  </td>
                                  <th>
                                    Company Name
                                  </th>
                                  <th>
                                    Company ID
                                  </th>
                                  <th>
                                    Name
                                  </th>
                                  <th>
                                    Role
                                  </th>
                                  <th>
                                    Position
                                  </th>
                                  <th>
                                    Contact Number
                                  </th>
                                  <th>
                                    Email
                                  </th>
                                  <th>
                                    GRC Manager
                                  </th>
                                  <th>
                                    Comments
                                  </th>
                                  <th>
                                    Current Plan
                                  </th>
                                  <th>
                                    CV Contacts Opened
                                  </th>
                                  <th onClick={() => handleColumnClick('created')}>
                                    <span style={{ cursor: 'pointer' }}>
                                      <CalendarMonthIcon /> Created {symbol}
                                    </span>
                                  </th>
                                  <th onClick={() => handleColumnClick('active')}>
                                    <span style={{ cursor: 'pointer' }}>
                                      <CalendarMonthIcon /> Active {symbol}
                                    </span>
                                  </th>
                                  <th scope='col'>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  listData.map(i => (
                                    <tr key={i.id}>
                                      <td className='checkBoxCol'>
                                        <input
                                          type='checkbox'
                                          className='tableCheckBox'
                                          onChange={() => handleCheck(i.id)}
                                          checked={checkedData.includes(i.id)}
                                        />
                                      </td>
                                      <td>
                                        {i.company_name}
                                        <span className='verifiedUsername'>
                                          {i.verify === 1 ? <VerifiedIcon /> : ''}
                                        </span>
                                      </td>
                                      <td>{i.employer_id}</td>
                                      <td>{i.first_name} {i.last_name}</td>
                                      <td>{i.role}</td>
                                      <td>{i.position}</td>
                                      <td>{i.contact}</td>
                                      <td
                                        style={{
                                          maxWidth: '200px',
                                          wordBreak: 'break-all',
                                          whiteSpace: 'pre-line',
                                          overflowWrap: 'break-word',
                                        }}
                                      >
                                        {i.email_address}
                                      </td>
                                      <td>{i.current_grc_manager}</td>
                                      <td style={{ maxWidth: '270px' }}>
                                        {i.notes}
                                      </td>
                                      <td>{i.plan}</td>
                                      <td>{i.count_view_cv}</td>
                                      <td>{DateUtilsService.formatEmployerDate(i.created)}</td>
                                      <td>{i.active ? formatDate(i.active) : '01.01.1970'}</td>
                                      <td className='APActionButton'>
                                        {
                                          i.status === 1
                                            ? (
                                              <button
                                                className='btn-secondary activated'
                                                onClick={() => handleDeactivate(i.slug)}
                                              >
                                                <Tooltip title='Deactivate'>
                                                  <CheckIcon />
                                                </Tooltip>
                                              </button>
                                            ) : (
                                              <button
                                                className='btn-secondary'
                                                onClick={() => handleActivate(i.slug)}
                                              >
                                                <Tooltip title='Activate'>
                                                  <BlockIcon />
                                                </Tooltip>
                                              </button>
                                            )
                                        }
                                        <button
                                          className='btn-primary'
                                          onClick={() =>navigate(`/admin/users/editusers/${i.slug}`)}
                                        >
                                          <Tooltip title='Edit'>
                                            <CreateIcon />
                                          </Tooltip>
                                        </button>
                                        <button
                                          className='btn btn-secondary'
                                          onClick={() => handleDelete(i.slug)}
                                        >
                                          <Tooltip title='Delete'>
                                            <DeleteIcon />
                                          </Tooltip>
                                        </button>
                                        {
                                          !i.verify && (
                                            <button
                                              className='btn-primary'
                                              onClick={() => handleVerify(i.slug)}
                                            >
                                              <Tooltip title='Verify Now'>
                                                <VerifiedUserIcon />
                                              </Tooltip>
                                            </button>
                                          )
                                        }
                                        <button
                                          className='btn-primary'
                                          onClick={() => handleOpen(i)}
                                        >
                                          <Tooltip title='View'>
                                            <RemoveRedEyeIcon />
                                          </Tooltip>
                                        </button>
                                        <button
                                          className='btn-primary'
                                          onClick={() => handleLogIn(i.id)}
                                        >
                                          <Tooltip title='View'>
                                            <LoginIcon />
                                          </Tooltip>
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                                }
                              </tbody>
                            </table>
                          </div>
                          <div className='manageSubadminpart3'>
                            <div className='functionalityButton'>
                              <button
                                type='button'
                                className='btn btn-primary APButton3'
                                onClick={() => handleMultipleActivate()}
                              >
                                MASS ACTIVATE
                              </button>
                              <button
                                type='button'
                                className='btn btn-primary APButton3'
                                onClick={() => handleMultipleDeactivate()}
                              >
                                MASS DEACTIVATE
                              </button>
                              <button
                                type='button'
                                className='btn btn-primary APButton4'
                                onClick={() => handleMultipleDelete()}
                              >
                                MASS DELETE
                              </button>
                            </div>
                            <div className='mb-5 pagination'>
                              <Stack spacing={2}>
                                <Pagination
                                  color='primary'
                                  boundaryCount={2}
                                  count={totalPages}
                                  page={currentPage}
                                  onChange={(event, page) => handlePageChange(page)}
                                />
                              </Stack>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className='appliedJobListNoData'>No Records Found</div>
                      )
                  }
                  <div>
                    <Modal
                      open={open}
                      className='modalMain'
                      onClose={handleClose}
                      aria-labelledby='modal-modal-title'
                      aria-describedby='modal-modal-description'
                    >
                      <Box className='modal adminModal modal-content'>
                        <IconButton
                          onClick={handleClose}
                          className='close-button'
                          style={{
                            top: 10,
                            right: 10,
                            position: 'absolute',
                          }}
                        >
                          &times;
                        </IconButton>
                        <Typography
                          variant='h6'
                          component='h2'
                          id='modal-modal-title'
                        ></Typography>
                        <Typography
                          sx={{ mt: 3 }}
                          id='modal-modal-description'
                        >
                          {
                            selectedPayment && (
                              <div className='modals'>
                                <div className='modalHead'>
                                  <h1>
                                    {selectedPayment.first_name}
                                    {' '}
                                    {selectedPayment.last_name}
                                  </h1>
                                </div>
                                <div className='modalBody mt-4'>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Company Name:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.company_name}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Position:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.position}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      First Name:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.first_name}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Last Name:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.last_name}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Address:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.address}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Email Address:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.email_address}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Contact Number:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.contact}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Company Number:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.company_contact}
                                    </div>
                                  </div>
                                  <div className='modalParent'>
                                    <div className='modalLeft'>
                                      Website:{' '}
                                    </div>
                                    <div className='modalRight'>
                                      {selectedPayment.url}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                        </Typography>
                      </Box>
                    </Modal>
                  </div>
                </div>
              </>
            )
        }
      </div>
    </>
  );
};

export default APEmployerList;
